import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const questions = [
  { letter: "A", title: "Business Overview" },
  { letter: "B", title: "Current DAM Process" },
  { letter: "C", title: "Key Challenges" },
  { letter: "D", title: "Requirements" },
  { letter: "E", title: "Additional Notes" },
];

export default function HowHelp() {
  return (
    <Box
      sx={{
        backgroundColor: "#FFF",

        px: {
          xs: "16px",
          customBreakpoint: "24px",
          md: "84px",
        },

        py: {
          xs: "30px",
          customBreakpoint: "48px",
          py: "48px",
        },

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "24px",
              sm: "32px",
              md: "40px",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 1.25,
          }}
        >
          How It Helps
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              sm: "16px",
              md: "18px",
            },
            fontWeight: 400,
            color: "#666666",
            lineHeight: 1.7,
            // mb: 5,
          }}
        >
          A simple yet comprehensive form used during discovery sessions to capture as-is
          processes and business requirements.
        </Typography>
      </Box>

      {/* Card and its Data */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "#ECEFF1",
          border: "1px solid rgba(0,0,0,0.1)",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            height: 50,
            px: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#E0E0E0",
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <CalendarTodayOutlinedIcon sx={{ color: "rgba(0,0,0,0.54)" }} />

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 600,
                color: "rgba(0,0,0,0.87)",
              }}
            >
              DAM Discovery Framework
            </Typography>
          </Box>

          <IconButton
            sx={{
              width: 30,
              height: 30,
              bgcolor: "#F5F5F5",
              borderRadius: "4px",
            }}
          >
            <MoreHorizOutlinedIcon />
          </IconButton>
        </Box>

        {/* Body */}
        <Box
          sx={{
            p: 1,
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {questions.map(item => (
            <Box
              key={item.letter}
              sx={{
                height: 44,
                px: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: "#fff",
                borderRadius: "4px",
                cursor: "pointer",
                transition: "all .2s ease",

                "&:hover": {
                  boxShadow: 1,
                  transform: "translateY(-1px)",
                },
              }}
            >
              {/* Left */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minWidth: 0,
                  flex: 1,
                }}
              >
                {/* Circle */}
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    bgcolor: "#FFF8E1",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 600,
                      lineHeight: "24px",
                      color: "rgba(0,0,0,0.87)",
                    }}
                  >
                    {item.letter}
                  </Typography>
                </Box>

                {/* Text */}
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: 400,
                    color: "rgba(0,0,0,0.87)",
                    lineHeight: 1.5,
                    letterSpacing: "0.15px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.title}
                </Typography>
              </Box>

              {/* Arrow */}
              <ChevronRightIcon
                sx={{
                  color: "rgba(0,0,0,0.56)",
                  flexShrink: 0,
                }}
              />
            </Box>
          ))}

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              mt: 1,

              flexDirection: {
                xs: "row",
                sm: "row",
              },

              "& button": {
                height: 36,
                borderRadius: "4px",
                textTransform: "capitalize",
                fontWeight: 500,
                fontSize: "0.875rem",
                lineHeight: "24px",
                letterSpacing: "0.4px",
              },
            }}
          >
            <Button
              variant="contained"
              sx={{
                minWidth: 79,
                background: "#2A2177",
                boxShadow:
                  "0px 1px 5px rgba(0,0,0,0.12), 0px 2px 2px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.2)",

                "&:hover": {
                  background: "#241B67",
                },
              }}
            >
              Submit
            </Button>

            <Button
              variant="outlined"
              sx={{
                minWidth: 128,
                borderColor: "rgba(30,14,98,0.5)",
                color: "#2A2177",

                "&:hover": {
                  borderColor: "#2A2177",
                  background: "rgba(42,33,119,0.04)",
                },
              }}
            >
              Save For Later
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
